import { Swiper, Navigation, Pagination, Thumbs } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Thumbs]);

export default () => {
    var swiper = new Swiper('.gallery-modal-slider', {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
    });

    let mainSlide = new Swiper(".main-slide", {
      watchOverflow: true,
      pagination: {
        el: ".main-pagination",
        clickable: true,
      },
    });

    let companiesSlide = new Swiper(".companies__slide", {
      slidesPerView: 2.5,
      spaceBetween: 24,
      loop: true,
      navigation: {
        prevEl: ".companies__nav",
      },
      breakpoints: {
        375: {
          slidesPerView: 1.5,
          spaceBetween: 20
        },
        820: {
          slidesPerView: 4.5,
          spaceBetween: 40
        },
      }
    });

    var photosThumb = new Swiper(".photos-thumb", {
      spaceBetween: 10,
      slidesPerView: 5,
      freeMode: true,
      thumbsContainerClass: ".swiper-thumbs",
      slideThumbActiveClass: "swiper-slide-thumb-active",
      watchSlidesProgress: true,
    });

    var photos = new Swiper(".photos", {
      spaceBetween: 10,
      navigation: {
        nextEl: ".gallery-button-next",
        prevEl: ".gallery-button-prev",
      },
      pagination: {
        el: ".gallery-pagination",
        type: "bullets",
        clickable: true,
      },
      thumbs: {
        swiper: photosThumb,
      },
    });

    var productsSwiper = new Swiper(".products__slide", {
      slidesPerView: 3,
      spaceBetween: 40,
      navigation: {
        nextEl: ".products__next",
        prevEl: ".products__prev",
      },
      breakpoints: {
        375: {
          slidesPerView: 1.5,
          spaceBetween: 20
        },
        820: {
          slidesPerView: 3.5,
          spaceBetween: 40
        },
      }
    });
};
